import FormFieldViewText from "components/FormFields/ViewText";
import { GithubIntegration } from "types/generated";

import { VCSCheckLabels } from "./helpers";
import VCSIntegrationsUseGitCheckoutInfo from "./UseGitCheckoutInfo";

type VCSIntegrationsDetailsGitHubProps = {
  details: GithubIntegration;
};

const VCSIntegrationsDetailsGitHub = ({ details }: VCSIntegrationsDetailsGitHubProps) => {
  return (
    <>
      <VCSIntegrationsUseGitCheckoutInfo value={details.useGitCheckout} />
      <FormFieldViewText label="VCS checks" value={VCSCheckLabels[details.vcsChecks]} />
    </>
  );
};

export default VCSIntegrationsDetailsGitHub;
